import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BehaviorSubject, catchError, exhaustMap, map, of, switchMap } from "rxjs";
import { HotelsService } from "../services/hotels.service";
import { HotelsStateActions } from "./hotels.actions";

@Injectable()
export class HotelsEffects {
  constructor(
    private actions$: Actions,
    private hotelsService: HotelsService
  ) {}
  loadHotelsFilterOptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelsStateActions.loadHotelsFilterOptions),
      exhaustMap((query: any) => {
        //TODO: complete types
        return this.hotelsService
          .loadHotelFilterOptions(query.requestQuery)
          .pipe(
            map((res) => {
              const filterOptions = res;
              return HotelsStateActions.loadHotelsFilterOptionsSuccess({
                data: { filterOptions },
              });
            }),
            catchError((error: HttpErrorResponse) => {
              return of(
                HotelsStateActions.loadHotelsFilterOptionsFailure({
                  error: error?.message || String(error),
                } as any)
              );
            })
          );
      })
    )
  );
  loadHotels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelsStateActions.loadHotelsData),
      switchMap((query: any) => {
        //TODO: complete types
        return this.hotelsService.getHotels(query.requestQuery).pipe(
          map((res) => {
            const { hotels } = res;
            const { totalRecordsLeft, totalRecords } = res.metadata;
            return HotelsStateActions.loadHotelsDataSuccess({
              data: { hotels, totalRecordsLeft, totalRecords },
            });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(
              HotelsStateActions.loadHotelsDataFailure({
                error: error?.message || String(error),
              } as any)
            );
          })
        );
      })
    )
  );
  loadMoreHotels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelsStateActions.loadMoreHotelsData),
      exhaustMap((query: any) => {
        //TODO: complete types
        return this.hotelsService.getHotels(query.requestQuery).pipe(
          map((res) => {
            const { hotels } = res;
            const { totalRecordsLeft } = res.metadata;
            return HotelsStateActions.loadMoreHotelsDataSuccess({
              data: { hotels, totalRecordsLeft },
            });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(
              HotelsStateActions.loadMoreHotelsDataFailure({
                error: error?.message || String(error),
              } as any)
            );
          })
        );
      })
    )
  );
}
